export interface FaqItem {
  question: string
  answer: string
}

// 单一数据源：同时用于页面可见 FAQ 区块与 FAQPage JSON-LD，避免 cloaking
export const faqList: FaqItem[] = [
  {
    question: 'HowXM 浩客是什么？',
    answer:
      'HowXM（浩客）是一款应用内用户体验调研与反馈工具，帮助企业在 Web 网站、App、微信小程序等数字化产品内嵌入轻量级问卷、评价和通知，实时收集用户反馈，开展 NPS、满意度（CSAT）等体验调研，并精准触达用户。',
  },
  {
    question: 'HowXM 支持哪些平台？',
    answer:
      'HowXM 提供 Web SDK、iOS SDK、Android SDK 和微信小程序 SDK，可在网站、移动 App 和小程序中嵌入问卷与通知；同时支持通过链接或二维码分享对外表单，无需开发即可投放。',
  },
  {
    question: 'HowXM 和传统问卷工具有什么区别？',
    answer:
      '传统问卷工具依赖站外链接，触达率低、场景割裂。HowXM 在产品内部按用户行为、属性和时机精准触发问卷，所见即所得地在真实使用场景中收集反馈，回收率和数据质量更高，并能将反馈与具体用户和行为关联。',
  },
  {
    question: 'HowXM 适合哪些人使用？',
    answer:
      'HowXM 适合产品经理、用户体验（UED）设计师、客户成功和市场运营团队，用于功能反馈收集、NPS 调研、满意度调研、A/B 版本测试、付费流失调研、新功能引导和促销通知等场景。',
  },
  {
    question: 'HowXM 如何收费？是否有免费版？',
    answer:
      'HowXM 提供免费套餐和多档付费套餐，支持免费注册试用。具体功能与价格请查看定价页面（https://howxm.com/pricing）。',
  },
  {
    question: '使用 HowXM 需要开发投入吗？',
    answer:
      '基础使用只需一次性集成 SDK 或嵌入代码；之后问卷的创建、投放规则配置和数据分析均可在后台可视化完成，无需额外开发。对外表单则可零代码直接通过链接投放。',
  },
]
